import { serviceNetworkError } from "../failhandler";

var gantt = (function() {
		
    if ($("#ganttChart").length == 0)
        return;

    var data = {
        pageId: SETTINGS.pageid
    };    

	var ajaxRequest = $.ajax({
	    url: SETTINGS.services.admin.methods.getCampaigns,
	    data: JSON.stringify(data)
	});

	ajaxRequest.done(doneHandler);
	ajaxRequest.fail(failHandler);

	function doneHandler(response) {

	    //Convert unix timestamp to javascript date
	    for (var i = 0; i < response.length; i++) {
            
	        var serie = response[i].series[0];

	        serie.start = new Date(serie.start);
	        serie.end = new Date(serie.end);
	    }	   

	    $("#ganttChart").ganttView({ 
	        data: response,
	        slideWidth: 788,
	        behavior: {
	            resizable: false,
	            draggable: false,
	            onClick: function (data) {
	                window.location = window.location.origin + '/' + data.link;
	            }
	        }
	    });
	}

	function failHandler(jqXHR, textStatus, errorThrown) {
	    serviceNetworkError($("#ganttChart"));
	}	

})();